import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { Container } from 'reactstrap'
import ShareButton from '../components/ShareButton'

import { sfbFaqs } from '../utils/constants/faqs'

function FAQPage() {
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  const handleToggleFaq = index => {
    setOpenFaqIndex(currentIndex => currentIndex === index ? null : index);
  };

  return (
    <div className="page-content pb-5">
        <section className="page-band page-band--hero section-shell surface-elevated">
            <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3">
            <div>
                <h1 className="display-6 mb-2 text-uppercase text-light londrina-outline-regular">
                    Frequently Asked Questions
                </h1>
                <p className="mb-0 text-secondary">
                    Everything you need to know before reserving your username or joining a beta role.
                </p>
            </div>
            <div className="d-flex flex-wrap gap-2">
                <Link to="/#signup-section" className="btn btn-outline-primary btn-cta fw-semibold border-2 px-4 text-uppercase">
                    Reserve Username
                </Link>
                <ShareButton size="lg" />
            </div>
            </div>
        </section>

        <section className="page-band section-shell surface-elevated">
            <Container fluid className="px-0">
                <div className="d-flex flex-column gap-4">
                    {sfbFaqs.map(({ question, answer }, index) => {
                        const isOpen = openFaqIndex === index;
                        const answerId = `faq-answer-${index}`;
                        const headingId = `faq-heading-${index}`;

                        return (
                            <article
                                key={question}
                                className={`panel-card rounded-3 overflow-hidden border-0 ${isOpen ? 'shadow' : 'shadow-sm'}`}
                                style={{ backgroundColor: 'var(--sfb-bg-1)', borderColor: 'var(--sfb-border-subtle)' }}
                            >
                                <h2 className="mb-0 surface-elevated">
                                    <button
                                        type="button"
                                        id={headingId}
                                        aria-expanded={isOpen}
                                        aria-controls={answerId}
                                        onClick={() => handleToggleFaq(index)}
                                        className="w-100 d-flex align-items-center justify-content-between gap-3 text-start bg-transparent border-0 panel-card-body"
                                    >
                                        <span className={`h3 mb-0 annie-use-your-telescope-regular sfb-inline ${isOpen ? 'text-primary-orange fw-bold' : 'text-light'}`}>
                                            {question}
                                        </span>
                                        <span
                                            aria-hidden="true"
                                            className="fs-4 fw-semibold text-primary-orange flex-shrink-0"
                                            style={{
                                              lineHeight: 1,
                                              transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                                              transition: 'transform var(--sfb-motion-fast) ease'
                                            }}
                                        >
                                            +
                                        </span>
                                    </button>
                                </h2>

                                {isOpen && (
                                    <div
                                        id={answerId}
                                        role="region"
                                        aria-labelledby={headingId}
                                        className="px-3 px-sm-4 pb-3 pb-sm-4 pt-0 border-top border-primary-orange-subtle sfb-inline text-light"
                                    >
                                        <p className="mb-0 pt-3 text-secondary section-subtitle">
                                            {answer}
                                        </p>
                                    </div>
                                )}
                            </article>
                        );
                    })}
                </div>
            </Container>
        </section>
    </div>
  )
}

export default FAQPage
